export const OidcQueryParameterNames = {
  ReturnUrl: 'returnUrl',
  Message: 'message'
};

export const OidcLogoutActions = {
  LogoutCallback: 'logout-callback',
  Logout: 'logout',
  LoggedOut: 'logged-out'
};

export const OidcLoginActions = {
  Login: 'login',
  LoginCallback: 'login-callback',
  LoginFailed: 'login-failed',
  Profile: 'profile',
  Register: 'register'
};
